<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <Modal
      :id="modalId"
      :options="options"
      :title="`Want to delete ${target.profile.nickname}'s account?`"
    >
      <div class="tw-m-4 tw-mb-8">
        This user's account will be permanently deleted!
      </div>

      <div class="tw-flex tw-justify-end">
        <button
          type="button"
          class="btn btn-lg btn-gradient"
          :data-cy="`cancel-button`"
          @click.prevent="hideModal"
        >
          Nevermind
        </button>
        <button
          type="button"
          class="tw-ml-2 btn btn-lg btn-gradient"
          :data-cy="`ok-button`"
          @click.prevent="deleteUser"
        >
          Delete Account
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import modalHelpers from '@/mixins/helpers/modal-helpers';

export default {
  mixins: [
    modalHelpers, //
  ],

  data() {
    return {
      options: {
        size: 'md',
      },
    };
  },

  computed: {
    modalId() {
      return 'user:delete';
    },
  },

  methods: {
    deleteUser() {
      console.log('deleting user...', this.target.id);

      this.$http.post(`/api/admin/user/${this.target.id}/delete`).then(() => {
        this.$store.set('general/loading', false);
        this.$root.$emit('bv::hide::modal', this.modalId);

        this.$swal('User Deleted', 'Operation was succesful', 'success');

        Bus.$emit('refresh');
      });
    },
  },
};
</script>
